module.exports = __webpack_public_path__ + "img/show-filter-icon.7a517e1f.svg";